import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MedChronReference } from './schemas'

export type MedChronReferencesRecord = { [reference_id: string]: MedChronReference }

export type MedChronReferencesState = {
  references: { [storeKey: string]: MedChronReferencesRecord }
}

const initialState: MedChronReferencesState = {
  references: {},
}

export const medChronReferencesSlice = createSlice({
  name: 'medChronReferencesState',
  initialState,
  reducers: {
    nullifyData: () => initialState,

    setReferencesRecord: (state, action: PayloadAction<{ storeKey: string; references: MedChronReferencesRecord }>) => {
      state.references[action.payload.storeKey] = action.payload.references
    },
  },
})

// Actions
export const MedChronReferencesActions = medChronReferencesSlice.actions

export default medChronReferencesSlice.reducer
